import SideBar from "./components/SideBar"
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom"
import Home from "./pages/home"
import Projects from "./pages/projects"
import Contact from "./pages/contact"
import Resume from "./pages/resume"
import ParticleBackground from "./p5/particlebackground"
function AppContent() {
  const location = useLocation()
  const showBackground = location.pathname === "/" || location.pathname === "/projects"

  return (
    <div className="relative">
      {showBackground && <ParticleBackground />}
      <SideBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/resume" element={<Resume />} />
      </Routes>
    </div>
  )
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  )
}

export default App

